var fontArray = [
    { label: 'Arial', value: 'Arial', src: 'mpz', group: 'Full Support' },
    { label: 'Arial Black', value: 'Arial Black', src: 'mpz', group: 'Full Support' },
    { label: 'Comic Sans MS', value: 'Comic Sans MS', src: 'mpz', group: 'Full Support' },
    { label: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode', src: 'mpz', group: 'Full Support' },
    { label: 'Helvetica', value: 'Helvetica', src: 'mpz', group: 'Full Support' },
    { label: 'Impact', value: 'Impact', src: 'mpz', group: 'Full Support' },
    { label: 'Tahoma', value: 'Tahoma', src: 'mpz', group: 'Full Support' },
    { label: 'Trebuchet MS', value: 'Trebuchet MS', src: 'mpz', group: 'Full Support' },
    { label: 'Calibri', value: 'Calibri', src: 'mpz', group: 'Full Support' },
    { label: 'Verdana', value: 'Verdana', src: 'mpz', group: 'Full Support' },
    { label: 'Courier New', value: 'Courier New', src: 'mpz', group: 'Full Support' },
    { label: 'Garamond', value: 'Garamond', src: 'mpz', group: 'Full Support' },
    { label: 'Georgia', value: 'Georgia', src: 'mpz', group: 'Full Support' },
    { label: 'Times New Roman', value: 'Times New Roman', src: 'mpz', group: 'Full Support' },
    { label: 'Lucida', value: 'Lucida', src: 'mpz', group: 'Full Support' },
    { label: 'Trebuchet', value: 'Trebuchet', src: 'mpz', group: 'Full Support' },
    {
        label: 'Open Sans',
        value: 'Open Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Open Sans Condensed',
        value: 'Open Sans Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Libre Baskerville',
        value: 'Libre Baskerville,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cabin',
        value: 'Cabin,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Rubik',
        value: 'Rubik,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Hind',
        value: 'Hind,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Fjalla One',
        value: 'Fjalla One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Arvo',
        value: 'Arvo,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Lobster',
        value: 'Lobster,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Libre Franklin',
        value: 'Libre Franklin,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Exo 2',
        value: 'Exo 2,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Karla',
        value: 'Karla,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Pacifico',
        value: 'Pacifico,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Abel',
        value: 'Abel,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Varela Round',
        value: 'Varela Round,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Yanone Kaffeesatz',
        value: 'Yanone Kaffeesatz,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Nunito Sans',
        value: 'Nunito Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Merriweather Sans',
        value: 'Merriweather Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Shadows Into Light',
        value: 'Shadows Into Light,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Dancing Script',
        value: 'Dancing Script,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Source Serif Pro',
        value: 'Source Serif Pro,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Source Code Pro',
        value: 'Source Code Pro,monospace',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Abril Fatface',
        value: 'Abril Fatface,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Ubuntu',
        value: 'Ubuntu,sans-serif',
        src: 'google',
        group: 'Limited Support',
        weights: [400, 700]
    },
    {
        label: 'Ubuntu Condensed',
        value: 'Ubuntu Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Bree Serif',
        value: 'Bree Serif,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Acme',
        value: 'Acme,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Asap',
        value: 'Asap,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Archivo Narrow',
        value: 'Archivo Narrow,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Questrial',
        value: 'Questrial,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Gloria Hallelujah',
        value: 'Gloria Hallelujah,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'PT Sans Caption',
        value: 'PT Sans Caption,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Encode Sans Condensed',
        value: 'Encode Sans Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Kanit',
        value: 'Kanit,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Exo',
        value: 'Exo,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Signika',
        value: 'Signika,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Amatic SC',
        value: 'Amatic SC,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Comfortaa',
        value: 'Comfortaa,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Merienda',
        value: 'Merienda,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Hind Siliguri',
        value: 'Hind Siliguri,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Play',
        value: 'Play,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Maven Pro',
        value: 'Maven Pro,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'EB Garamond',
        value: 'EB Garamond,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Teko',
        value: 'Teko,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cairo',
        value: 'Cairo,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Francois One',
        value: 'Francois One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Crete Round',
        value: 'Crete Round,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Rokkitt',
        value: 'Rokkitt,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Patua One',
        value: 'Patua One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cinzel',
        value: 'Cinzel,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Righteous',
        value: 'Righteous,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Heebo',
        value: 'Heebo,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Vollkorn',
        value: 'Vollkorn,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cuprum',
        value: 'Cuprum,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Permanent Marker',
        value: 'Permanent Marker,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Alegreya',
        value: 'Alegreya,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Catamaran',
        value: 'Catamaran,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Old Standard TT',
        value: 'Old Standard TT,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Domine',
        value: 'Domine,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Pathway Gothic One',
        value: 'Pathway Gothic One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Ropa Sans',
        value: 'Ropa Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Satisfy',
        value: 'Satisfy,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Concert One',
        value: 'Concert One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Great Vibes',
        value: 'Great Vibes,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Kaushan Script',
        value: 'Kaushan Script,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'ABeeZee',
        value: 'ABeeZee,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Courgette',
        value: 'Courgette,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Didact Gothic',
        value: 'Didact Gothic,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Noticia Text',
        value: 'Noticia Text,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Rajdhani',
        value: 'Rajdhani,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cardo',
        value: 'Cardo,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Fira Sans Condensed',
        value: 'Fira Sans Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Prompt',
        value: 'Prompt,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Assistant',
        value: 'Assistant,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'News Cycle',
        value: 'News Cycle,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cookie',
        value: 'Cookie,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Quattrocento Sans',
        value: 'Quattrocento Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Alegreya Sans',
        value: 'Alegreya Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Poiret One',
        value: 'Poiret One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Istok Web',
        value: 'Istok Web,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Josefin Slab',
        value: 'Josefin Slab,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Orbitron',
        value: 'Orbitron,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Quattrocento',
        value: 'Quattrocento,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Monoton',
        value: 'Monoton,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Arapey',
        value: 'Arapey,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Monda',
        value: 'Monda,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Amiri',
        value: 'Amiri,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Lobster Two',
        value: 'Lobster Two,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cormorant Garamond',
        value: 'Cormorant Garamond,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Archivo Black',
        value: 'Archivo Black,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Archivo',
        value: 'Archivo,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Khand',
        value: 'Khand,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Volkhov',
        value: 'Volkhov,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Caveat',
        value: 'Caveat,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Passion One',
        value: 'Passion One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Kalam',
        value: 'Kalam,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Russo One',
        value: 'Russo One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Fredoka One',
        value: 'Fredoka One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Tinos',
        value: 'Tinos,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Alfa Slab One',
        value: 'Alfa Slab One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Yantramanav',
        value: 'Yantramanav,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Tangerine',
        value: 'Tangerine,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Sacramento',
        value: 'Sacramento,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Nanum Myeongjo',
        value: 'Nanum Myeongjo,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Bangers',
        value: 'Bangers,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Economica',
        value: 'Economica,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Luckiest Guy',
        value: 'Luckiest Guy,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Basic',
        value: 'Basic,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Handlee',
        value: 'Handlee,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Hind Madurai',
        value: 'Hind Madurai,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'DM Sans',
        value: 'DM Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'BenchNine',
        value: 'BenchNine,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Playfair Display SC',
        value: 'Playfair Display SC,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Pontano Sans',
        value: 'Pontano Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Gudea',
        value: 'Gudea,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cabin Condensed',
        value: 'Cabin Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Chivo',
        value: 'Chivo,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Cantarell',
        value: 'Cantarell,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Pragati Narrow',
        value: 'Pragati Narrow,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Neuton',
        value: 'Neuton,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Tajawal',
        value: 'Tajawal,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Philosopher',
        value: 'Philosopher,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'M PLUS 1p',
        value: 'M PLUS 1p,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Barlow',
        value: 'Barlow,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Patrick Hand',
        value: 'Patrick Hand,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Sanchez',
        value: 'Sanchez,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Hammersmith One',
        value: 'Hammersmith One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Vidaloka',
        value: 'Vidaloka,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Khula',
        value: 'Khula,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Frank Ruhl Libre',
        value: 'Frank Ruhl Libre,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Boogaloo',
        value: 'Boogaloo,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Armata',
        value: 'Armata,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Fira Sans Extra Condensed',
        value: 'Fira Sans Extra Condensed,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Amaranth',
        value: 'Amaranth,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Zilla Slab',
        value: 'Zilla Slab,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Yrsa',
        value: 'Yrsa,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Glegoo',
        value: 'Glegoo,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Sorts Mill Goudy',
        value: 'Sorts Mill Goudy,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Marck Script',
        value: 'Marck Script,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Unica One',
        value: 'Unica One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Ruda',
        value: 'Ruda,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Audiowide',
        value: 'Audiowide,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Ultra',
        value: 'Ultra,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Montserrat',
        value: 'Montserrat,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Montserrat Alternates',
        value: 'Montserrat Alternates,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Prosto One',
        value: 'Prosto One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Eczar',
        value: 'Eczar,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Paytone One',
        value: 'Paytone One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Architects Daughter',
        value: 'Architects Daughter,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Gentium Basic',
        value: 'Gentium Basic,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Signika Negative',
        value: 'Signika Negative,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Oleo Script',
        value: 'Oleo Script,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'PT Mono',
        value: 'PT Mono,monospace',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Shadows Into Light Two',
        value: 'Shadows Into Light Two,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Enriqueta',
        value: 'Enriqueta,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Antic Slab',
        value: 'Antic Slab,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Alice',
        value: 'Alice,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Yellowtail',
        value: 'Yellowtail,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Hind Vadodara',
        value: 'Hind Vadodara,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Kreon',
        value: 'Kreon,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Sigmar One',
        value: 'Sigmar One,display',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Prata',
        value: 'Prata,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Neucha',
        value: 'Neucha,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Bad Script',
        value: 'Bad Script,handwriting',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Julius Sans One',
        value: 'Julius Sans One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Julius Sans One',
        value: 'Julius Sans One,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Roboto',
        value: 'Roboto,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Roboto Slab',
        value: 'Roboto Slab,serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Lato',
        value: 'Lato,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Oswald',
        value: 'Oswald,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Source Sans Pro',
        value: 'Source Sans Pro,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Red Hat Display',
        value: 'Red Hat Display,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Maitree',
        value: 'Maitree,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Poppins',
        value: 'Poppins,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Albert Sans',
        value: 'Albert Sans,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Figtree',
        value: 'Figtree,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Raleway',
        value: 'Raleway,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Inter',
        value: 'Inter,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Outfit',
        value: 'Outfit,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Carlito',
        value: 'Carlito,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Instrument Serif',
        value: 'Instrument Serif,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Manrope',
        value: 'Manrope,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Playfair Display',
        value: 'Playfair Display,sans-serif',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Century Gothic',
        value: 'Century Gothic',
        src: 'google',
        group: 'Limited Support'
    },
    {
        label: 'Crimson Pro',
        value: 'Crimson Pro,serif',
        src: 'google',
        group: 'Limited Support'
    }
].sort((a, b) => {
    if (a.label.toLowerCase() < b.label.toLowerCase()) return -1
    if (a.label.toLowerCase() > b.label.toLowerCase()) return 1
    return 0
})

module.exports = fontArray
